import { TimeCodeType } from 'state';
import { convertTimeToNumber } from 'utils';

export const checkTimeIsBetween = (
  progressVideo: number,
  timecode: TimeCodeType | undefined,
) => {
  if (!timecode) return;

  if (timecode.inspectionTimecodeStart && timecode.inspectionTimecodeEnd) {
    return (
      timecode.inspectionTimecodeStart <= progressVideo &&
      timecode.inspectionTimecodeEnd > progressVideo
    );
  }

  return (
    timecode &&
    convertTimeToNumber(timecode.timecodeStart) <= progressVideo &&
    convertTimeToNumber(timecode.timecodeEnd) > progressVideo
  );
};
